<template>
    <div>
        <top-bar
            activeTab="home"
            :lbl="lbl"
            :profile="profile"
            :isLogin="isLogin"
            :modalController="modalController"
            @switchLang="switchLang($event)"
            @logout="logout()"
        ></top-bar>
        <div class="container mt-4">
            <button @click="testApi(1)">1 sec</button>
            <button @click="testApi(2)">2 sec</button>
            <button @click="testApi(3)">3 sec</button>
            <button @click="testApiError()">testError</button>
            <button @click="testApiBackground()">testApiBackground</button>
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>

<script>
// @ is an alias to /src
// import Vue from "vue";
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import Account from "@/helper/AccountHelper.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import { TrackingService } from "@/helper/TrackingHelper.js";

import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";

import BzbsShoppingCart from "@/core/Cart/service/BzbsCart.js";
import FakeService from "./service/FakeService";

export default {
    name: "Interceptor",
    components: {
        TopBar
    },
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            isLogin: false,
            profile: {},

            name: "Hello",
            modelLogin: {
                username: "aaabbbccc",
                password: "11111111"
            },

            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null,

            tracking: new TrackingService(this)
        };
    },
    mounted: function() {},
    created: function() {
        Account.loginStatus().then(status => {
            this.isLogin = status;
            if (status) {
                this.profile = Account.getCacheProfile();
            }
        });
    },
    methods: {
        testApiBackground: function() {
            console.log("do job");
            FakeService.fakeGetBackGround(3).then(() => {
                console.log("done1");
            });
            FakeService.fakeGetBackGround(6).then(() => {
                console.log("done2");
            });
        },
        testApiError: function() {
            FakeService.fakeGet(1).then(() => {});
            FakeService.fakeGetError(1 + 2).then(() => {});
            FakeService.fakeGetError(1 + 3 + 1).then(() => {});
        },
        testApi: function(delay) {
            FakeService.fakeGet(delay).then(() => {});
            FakeService.fakeGet(delay + 1).then(() => {});
            FakeService.fakeGet(delay + 2 + 3).then(() => {});
        },
        login: function() {
            Account.apiBzbsLogin(
                this.modelLogin.username,
                this.modelLogin.password
            )
                .then(objResult => {
                    this.isLogin = true;
                    this.profile = objResult.profile;
                    console.log(objResult);
                })
                .catch(error => {
                    console.log(error);
                    this.errorApi(error);
                });
        },

        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },

        //#region test something
        getShoppingCartList: function() {
            BzbsShoppingCart.apiGetShoppingCartItem(null)
                .then(res => {
                    console.log(res);
                })
                .catch(err => {
                    // method (1)
                    // this.errorResponse(err);

                    // method (2)
                    var errorHandler = new ErrorHandler();
                    errorHandler.onError401 = () => {
                        this.confirmModal
                            .clearModal()
                            .setMsg("กรุณา Login ก่อน")
                            .setBtnOk("Login")
                            .setBtnCancel("Cancel")
                            .show();
                    };
                    this.errorApi(err, errorHandler);
                });
        },
        //#endregion test something

        // all new modal
        clickShowAlert: function() {
            this.alertModal
                .clearModal()
                .setTitle("This is title")
                .setMsg("modal message")
                .setBtnOk("Button ok")
                .setTag("alert-1")
                .show();
            this.alertModal.onClickOk(data => {
                console.log(data);
                console.log("alert ok");
            });
            this.alertModal.onHidden(data => {
                console.log(data);
                console.log("alert hidden");
            });
        },
        clickShowLoading: function() {
            this.loadingModal.show();
        },
        clickShowConfirm: function() {
            this.confirmModal
                .clearModal()
                .setTitle("Header confirm")
                .setMsg("Message Confirm")
                .setBtnOk("YES")
                .setBtnCancel("NO")
                .setTag("test-confirm")
                .show();
            this.confirmModal.onClickOk(data => {
                console.log(data);
                console.log("click confirm");
            });
            this.confirmModal.onClickCancel(data => {
                console.log(data);
                console.log("click cancel");
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.div-flex {
    display: flex;
}
</style>
